import { buildApiUrl, buildApiFallbackUrl } from './urlBuilder';

export default async function fetchWithFallback<ResType>(path: string): Promise<ResType> {
  try {
    const url = buildApiUrl(path);
    const res = await fetch(url);

    if (!res.ok) {
      throw new Error(`Status error fetching ${url}: ${res.status}`);
    }

    return await res.json();
  } catch (err: any) {
    // Fallback in case cloudflare cache will block original request
    const url = buildApiFallbackUrl(path);
    const res = await fetch(url);

    if (!res.ok) {
      throw new Error(`Status error on fallback, fetching ${url}: ${res.status}`);
    }

    return res.json();
  }
}
